export default __webpack_public_path__ + "static/media/weather-icons.f233d1da.svg";